export default __webpack_public_path__ + "static/media/wifi.98ef7bb3.png";